<template>
<div>
    <div class="row" style="height:auto;min-height:100vh">
        
            <div class="col"></div>
            <div v-if="isValidTicket&&ticketObj.planType == 'ticket'" class="col-12 col-sm-10 col-lg-6 vertical-align-center">
                <div class="card">
                    <img class="card-img-top" :src="getTicketFace()">
                    <div class="card-body">
                        <h3 class="card-title">
                            {{ticketObj.planName}}
                        </h3>
                        <div class="card-text ">
                            <p v-html="urlify(this.ticketObj.planDescription)"></p>
                        </div>                 
                    </div>
                        <div v-if="toggleRedeem" class="card-footer">
                            <long-press-button v-if="!isRedeemed" :state="'press'" :slotText="$t('Long Press')" :slotSmall="$t('Long Press to Redeem')" @activated.once="longPressRedeem"> 
                            </long-press-button>
                            <long-press-button v-if="isRedeemed&&errorMsg!=''" :state="'error'" :slotText="$t('Redeem failed')" :slotSmall="errorMsg" > 
                            </long-press-button>
                            <long-press-button v-if="isRedeemed&&errorMsg==''" :state="'redeemed'" :slotText="$t('Success')" :slotSmall="$t('Redeemded Successfully')" > 
                            </long-press-button>
                        </div>
                        <div v-if="!toggleRedeem" class="card-footer text-center">
                            <h3 v-if="!isRedeemed" class="p-4  alert-info" @click="toggleRedeem=!toggleRedeem">{{'Staff Redeem' | translate}}</h3>
                            <h4 v-if="isRedeemed&&errorMsg==''" class="p-4 alert-secondary">{{'The Ticket has been redeemed.' | translate}}</h4>
                            
                        </div>
                </div>
            </div>
            <div v-if="isValidTicket&&ticketObj.planType == 'card'" class="col-12 col-sm-10 col-lg-6 vertical-align-center" >
                <!-- <div style="height:100vh;display:flex" class="align-items-center"> -->
                    <div class="card" >
                        <img class="card-img-top" :src="getTicketFace()">

                        <div class="col-10">
                            <small class="text-muted">{{'Expiration:' | translate}}{{ticketObj.expiration}}</small>
                        </div>
                        

                    </div>
                <!-- </div> -->
                                
            </div>
            <div v-if="isValidTicket&&ticketObj.planType == 'dynamic-coupon-code'" class="col-12 col-sm-10 col-lg-6 vertical-align-center" >
                    <div class="card" >
                        <img class="card-img-top" :src="getTicketFace()">
                        <div v-if="ticketObj.dynamicCouponCode" class="code-space">
                            <h1 v-if="ticketObj.dynamicCouponCode.format=='text' || !ticketObj.dynamicCouponCode.format" class="text-center">
                                {{ticketObj.dynamicCouponCode.code}}
                            </h1>
                            <div v-else-if="ticketObj.dynamicCouponCode.format.split('-')[0]=='qrcode'">
                                
                            </div>
                            <barcode v-else-if="ticketObj.dynamicCouponCode.format.split('-')[0]=='barcode'"
                                :value="ticketObj.dynamicCouponCode.code" 
                                format="CODE39">
                                {{$t('Barcode render error')}}
                            </barcode>

                        </div>
                        <div class="card-body">
                            <h3 class="card-title">
                                {{ticketObj.planName}}
                            </h3>
                            <div class="card-text ">
                                <p v-html="urlify(this.ticketObj.planDescription)"></p>
                            </div>
                            <small class="text-muted">{{'Expiration:' | translate}}{{ticketObj.expiration}}</small>                   
                        </div>
                    </div>      
            </div>
            <div v-if="isValidTicket&&ticketObj.planType == 'scratch-card'" class="col-12 col-sm-10 col-lg-6 vertical-align-center" >
                    <div class="card" >
                        <scratch-card 
                            ref="scratchCard"
                            :imageUrl="ticketObj.planImages.front"
                            :finishPercent="scratchCardOptions.finishPercent"
                            :brushUrl="scratchCardOptions.brushUrl"
                            :forceReveal="scratchCardOptions.forceReveal">
                            <div class="scratch-body" :style="{'background':ticketObj.planImages.back?`center/cover url(${ticketObj.planImages.back})`:'#e9ecef'}">
                                <h1 v-if="ticketObj.scratchCard" class="text-center">{{ticketObj.scratchCard.message}}</h1>
                            </div>
                        </scratch-card>
                        <div class="card-body">
                            <h3 class="card-title">
                                {{ticketObj.planName}}
                            </h3>
                            <div class="card-text ">
                                <p v-html="urlify(this.ticketObj.planDescription)"></p>
                            </div>
                            <small class="text-muted">{{'Expiration:' | translate}}{{ticketObj.expiration}}</small>                   
                        </div>
                    </div>      
            </div>

            <div v-if="!isValidTicket" class="col-12 col-sm-10 col-lg-6 vertical-align-center">
                <div class="card">
                    <img v-if="isLoading" class="card-img-top" :src="'https://dummyimage.com/1280x640/888888/ffffff&text='+$t('Loading Ticket...')">
                    <img v-if="!isLoading" class="card-img-top" :src="'https://dummyimage.com/1280x640/888888/ffffff&text='+$t('Invalid Ticket')">
                </div>
            </div>
            <div class="col"></div>

    </div>
    <div class="row">
        <div style="height:2rem"></div>
        <div style="z-index:100;position:fixed;bottom:0;right:0;padding-right:4px;color:black;width:100vw;background-color:white;font-size:1rem">
                <!-- <small style="float:left" v-if="isValidTicket" >{{'Ticket ID:' | translate}} {{ticketObj.ticketID}}</small> -->
                <small style="float:right">{{'Powered by Sharelike.' | translate}}</small>
        </div>
        <!-- <div class="col-12" style="">
                <small style="float:right">{{'Powered by Sharelike.' | translate}}</small>
        </div> -->
    </div>
</div>   
</template>
<script>
import firebase from 'firebase';
import LongPressButton from './LongPressButton.vue';
import VueBarcode from 'vue-barcode';
// import { log } from 'util';
import ScratchCard from '@/components/TicketTypes/ScratchCard/vue-scratchcard.modified.vue';
import Brush from '@/assets/brush.png';


export default {
    components: {
            longPressButton: LongPressButton,
            scratchCard: ScratchCard,
            barcode: VueBarcode
        },
    data(){
        return {
            toggleRedeem:false,
            isLoading:true,
            isRedeemed:false,
            userID:'',
            ticketObj:null,
            isValidTicket:false,
            code:'',
            errorMsg:'',
            scratchCardOptions:{
                // cardWidth: 300,
                // cardHeight: 300,
                imageUrl:"https://avatars2.githubusercontent.com/u/1077546?s=460&v=4",
                finishPercent: 95,
                brushUrl: Brush,
                forceReveal: false,
            }
            
        }
    },
    watch:{
        ticketObj(value){
            if(value.status == 'redeemed')
                this.isRedeemed = true;
            if(value.planName)
                document.title = value.planName;
        }

    },
    computed:{
        
    },
    methods:{
        urlify(str) {//move to mixin
            var urlRegex = /(https?:\/\/[^\s]+)/g
                return str.replace(urlRegex, function(url) {
                    return '<a href="' + url + '" target="_blank">' + url + '</a>'
                })
            
        },
        validateTicket(){
            console.log('Validating Ticket...' + this.$route.params.key);
            var self = this;
            self.userID = self.$route.params.key.split("|")[0];
            var ticketID = self.$route.params.key.split("|")[1];
            var databaseRef = firebase.database().ref('users/' + self.userID + '/tickets');
            databaseRef.once('value')
                .then(function(snapshot) {
                    if(snapshot.hasChild(ticketID)){
                        console.log('Valid Key, Ticket exists');
                        self.isValidTicket = true;
                        self.isLoading = false;
                        self.ticketObj = snapshot.val()[ticketID];
                        
                    }else{
                        console.log('Invalid Key, Ticket not exists');
                        self.isValidTicket = false;
                        self.isLoading = false;
                        
                    }
                },function(error){
                    console.log('Validate Ticket error: ' + error);
                });
        },
        getTicketFace(){
            if(!this.ticketObj.planImages)
                return false
            if(!this.isRedeemed)
                return this.ticketObj.planImages.front==null?'https://dummyimage.com/1280x640/888888/ffffff&text="Can not load Ticket front image."':this.ticketObj.planImages.front;
            else if(this.ticketObj.planImages.redeemed!=null)
                return this.ticketObj.planImages.redeemed;
            else
                return this.ticketObj.planImages.front;
        },
        longPressRedeem(){
            console.log('Start Redeeming');
            var self = this;
            self.isRedeemed = true;
            console.log('Redeeming Ticket id: ' + this.$route.params.key);
            var customerID = this.ticketObj.owner;
            this.ticketObj.owner = this.ticketObj.planID;
            this.ticketObj.status = 'redeemed';

            console.log('Checking Ticket if still there...' );
            var customerTicketRef = firebase.database().ref('users/' + self.userID + '/customers/' + customerID + '/tickets/' + self.ticketObj.ticketID);
            return customerTicketRef.once('value')
                .then(function(snapshot){
                    if(snapshot.val()!=null){
                        customerTicketRef.remove();
                    }else{
                        console.log('Throwing...Can not Redeem, the Ticket has gone.');
                        throw self.$t('Can not redeem, the Ticket has gone.');
                    }

                })
                .then(function(){
                    var userRef = firebase.database().ref('users/' + self.userID );
                    userRef.child('plans/' + self.ticketObj.planID + '/redeemedTickets/' + self.ticketObj.ticketID).set(self.ticketObj);                        
                })
                .then(function(){
                    var ticketRef = firebase.database().ref('users/' + self.userID + '/tickets/'  + self.ticketObj.ticketID);
                    ticketRef.child('status').set(self.ticketObj.status);
                    ticketRef.child('owner').set(self.ticketObj.owner);
                    
                })
                .then(()=>console.log('Ticket Redeemed successfully!'))
                .catch(function(error){
                     console.log(error);
                     self.errorMsg = error;
                });            
        },
        initMessengerExtension(){
            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/en_US/messenger.Extensions.js";
                fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'Messenger'));
            window.extAsyncInit = this.onMessengerSDKLoaded;
        },
        onMessengerSDKLoaded(){
            console.log('the Messenger Extensions JS SDK is done loading ');
            // this.getMessengerPSID();//推上Staging才拿得到PSID
        },
    },
    mounted(){
        this.initMessengerExtension();
        this.validateTicket();
    }
    
}
</script>
<style scoped>
p {
    white-space:pre-wrap;
    word-wrap: break-word;
}
.vertical-align-center{
    margin-top:auto;
    margin-bottom:auto;
}
.code-space{
    padding: 2rem 1rem;
    background-color: #e9ecef;
    display:flex;
    justify-content: center;
    align-items: center;
}
.scratch-body{
    height:100%;
    padding: 2rem 1rem;
    background-color: #e9ecef;
    background-size: cover; 
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
